import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { MediaDocumentModel } from '@modules/media/models/media-document.model';
import { ActionIcons, ButtonItem } from '@modules/ui/action-container/action-container.component';

import { Filetype } from '../enums/filetype.enum';

@Component({
  selector: 'mb-document-card',
  templateUrl: './document-card.component.html',
  styleUrls: ['./document-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentCardComponent implements OnInit {
  public documentIconClasses = ['document-icon-label'];

  @Input() document!: MediaDocumentModel;
  @Input() actions: ButtonItem[] = [
    {
      icon: ActionIcons.SHARE,
      class: 'btn btn-quaternary',
    },
    {
      icon: ActionIcons.BOOKMARK,
      class: 'btn btn-quaternary',
    },
    {
      icon: ActionIcons.DOWNLOAD,
      class: 'btn btn-quaternary',
    },
  ];
  @Output() actionClick = new EventEmitter<{ action: ActionIcons; resource: any }>();

  ngOnInit(): void {
    if (this.document.filetypeName === Filetype.DOCX) {
      this.documentIconClasses.push('docx-label');
    }

    if (this.document.filetypeName === Filetype.DOC) {
      this.documentIconClasses.push('doc-label');
    }
  }
}
